import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ContractDigitizationMohaRoutingModule } from './contract-digitzation-moha-routing.module';
import { ContractDigitizationMohaComponent } from './contract-digitzation-moha.component';
import { ListContractDigitizationMohaComponent } from './list-contract/list-contract.component';
import { AddContractDigitizationMohaComponent } from './add-contract/add-contract.component';;
import {SharedModule} from '../../../../../shared/shared.module';
import {TranslateModule} from '@ngx-translate/core';
import { FilterContractDigitizationEmploymentComponent } from './filter-contract-digitization/filter-contract-digitization.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {
    NgZorroAntdModule,
    NzAutocompleteModule,
    NzDatePickerModule,
    NzIconModule,
    NzInputModule,
    NzPopconfirmModule,
    NzSpinModule, NzTableModule, NzTagModule, NzToolTipModule
} from 'ng-zorro-antd';
import {NgxExtendedPdfViewerModule} from 'ngx-extended-pdf-viewer';
import { ViewContractComponent } from './view-contract/view-contract.component';
import {NgMatAutocompleteModule} from '../../../../../shared/components/autocomplete/autocomplete.module';
import { UploadMultiFileAttachmentsComponent } from './upload-multi-file-attachments/upload-multi-file-attachments.component';
import {ViewPropertiesDialogComponent} from './view-properties-dialog/view-properties-dialog.component'
import { FillLaborContractReportMohaComponent } from './fill-labor-contract-report-moha/fill-labor-contract-report-moha.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { NzInputNumberModule } from 'ng-zorro-antd/input-number';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { ContractSignStatusComponent } from './contract-sign-status/contract-sign-status.component';

@NgModule({
  declarations: [
      ContractDigitizationMohaComponent,
      ListContractDigitizationMohaComponent,
      AddContractDigitizationMohaComponent,
      FilterContractDigitizationEmploymentComponent,
      ViewContractComponent,
      UploadMultiFileAttachmentsComponent,
      FillLaborContractReportMohaComponent,
      ContractSignStatusComponent,
      ViewPropertiesDialogComponent],
    imports: [
        CommonModule,
        SharedModule,
        ContractDigitizationMohaRoutingModule,
        TranslateModule,
        ReactiveFormsModule,
        NzDatePickerModule,
        NgxExtendedPdfViewerModule,
        NgMatAutocompleteModule,
        FormsModule,
        NzAutocompleteModule,
        NzIconModule,
        NzInputModule,
        NzPopconfirmModule,
        NzSpinModule,
        NzTableModule,
        NzToolTipModule,
        NzTagModule,
        MatCheckboxModule,
        NzInputNumberModule,
        NzCheckboxModule,
        NgZorroAntdModule
    ],
    entryComponents: [ViewContractComponent, UploadMultiFileAttachmentsComponent, ViewPropertiesDialogComponent]
})
export class ContractDigitizationMohaModule { }
